import $ from 'jquery'
import {TweenLite} from 'gsap'
import utils from './WorldUtils'
const THREE = window.THREE
const Power4 = window.Power4

const THREEWorld = function (element, $bus) {
  this.init(element, $bus)
}

THREEWorld.prototype = {
  cameraAnimation: {},
  cameraLocked: false,
  cameraOffsets: {
    position: new THREE.Vector3(0, 0, 0),
    rotation: new THREE.Vector3(0, 0, 0)
  },
  clearCssScene () {
    this.cssScene.children.forEach(child => {
      this.cssScene.remove(child)
    })
  },
  addCssObject (object) {
    this.cssScene.add(object)
  },
  add (object) {
    if (this.scene.children.indexOf(object) === -1) {
      this.scene.add(object)
    }
  },
  remove (object) {
    this.scene.remove(object)
  },
  animate () {
    this.render()
    window.requestAnimationFrame(this.animate.bind(this))
  },
  init (element, $bus) {
    this.positionFactor = -0.1
    this.container = element
    this.$bus = $bus
    try {
      this.initRenderer()
    } catch (error) {
      throw error
    }
    this.initScene()
    this.initCamera()
    this.initCssObjects()
    this.addEventListeners()
  },
  initCssObjects () {
    this.cssRenderer = new THREE.CSS3DRenderer()
    this.cssRenderer.setSize(window.innerWidth, window.innerHeight)
    this.cssRenderer.domElement.style.position = 'absolute'
    this.cssRenderer.domElement.style.top = 0
    this.container.appendChild(this.cssRenderer.domElement)
  },
  initCamera () {
    this.SCREEN_WIDTH = window.innerWidth
    this.SCREEN_HEIGHT = window.innerHeight
    this.VIEW_ANGLE = 45
    this.ASPECT = this.SCREEN_WIDTH / this.SCREEN_HEIGHT
    this.NEAR = 0.1
    this.FAR = 200000
    this.camera = new THREE.PerspectiveCamera(this.VIEW_ANGLE, this.ASPECT, this.NEAR, this.FAR)
    this.backwardsCamera = new THREE.PerspectiveCamera(this.VIEW_ANGLE, this.ASPECT, this.NEAR, this.FAR)
    this.backwardsCamera.rotateY(Math.PI)
    this.scene.add(this.camera)
    this.camera.add(this.backwardsCamera)
    this.light = new THREE.PointLight()
    this.camera.add(this.light)
  },
  initRenderer () {
    try {
      this.renderer = new THREE.WebGLRenderer({
        antialias: true
      })
      this.renderer.setClearColor(0xf0f0f0)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.container.appendChild(this.renderer.domElement)
      this.renderer.domElement.addEventListener('webglcontextrestored', () => {
      })
      this.renderer.domElement.addEventListener('webglcontextlost', () => {
      })
    } catch (error) {
      console.error('cannot create renderer....', error)
      this.$bus.$emit('webglerror', error)
      throw error
    }
  },
  initScene () {
    this.scene = new THREE.Scene()
    this.scene.background = new THREE.Color(0xffffff)
    this.scene.fog = new THREE.FogExp2(0xeffffff, 0.0002)
    this.cssScene = new THREE.Scene()
  },
  addEventListeners () {
    window.addEventListener('resize', this.onWindowResize.bind(this), false)
    $(document).on('mousemove', this.onMouseMove.bind(this))
    $(this.container).click(this.onClick.bind(this))
    this.$bus.$on('USER_IS_TOUCHING', this.onUserTouch.bind(this))
    this.$bus.$on('enter-site', this.onEnterSite.bind(this))
  },
  onEnterSite () {
    this.animate()
  },
  onUserTouch () {
    if (!this.userIsTouching) {
      document.getElementById('world').addEventListener('touchmove', this.onTouchMove.bind(this), true)
      $(this.container).off('click')
      document.getElementById('world').addEventListener('touchend', this.onTouchEnd.bind(this), true)
      $(document).off('mousemove')
      this.userIsTouching = true
    }
  },
  onTouchMove (e) {
    if (this.currentPositionIndex === 0) { // disable touchmove on rooftop
      return
    }
    const touch = e.touches.item(0)
    if (this.previousTouch) {
      const touchDiff = {
        x: this.previousTouch.x - touch.clientX,
        y: this.previousTouch.y - touch.clientY
      }
      const movementFactor = 0.5
      this.camera.position.x += touchDiff.x * movementFactor
      this.camera.position.y -= touchDiff.y * movementFactor
    }
    this.previousTouch = {
      x: touch.clientX,
      y: touch.clientY
    }
    this.emitMouseMove(touch)
    if (e.changedTouches.length === 2) {
      this.pinched = true
    }
  },
  onTouchEnd (e) {
    if (!e.touches.length) {
      let moved = !!this.previousTouch
      if (!moved) {
        const {raycaster, mouse} = this.createRaycasterAndMouse(e.changedTouches[0])
        this.$bus.$emit('touchend', {touchEvent: e, raycaster, mouse, moved})
      }
      this.previousTouch = null
    }
  },
  onWindowResize () {
    this.camera.aspect = window.innerWidth / window.innerHeight
    this.camera.updateProjectionMatrix()
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    if (this.cssRenderer) {
      this.cssRenderer.setSize(window.innerWidth, window.innerHeight)
    }
  },
  render: function () {
    if (this.scene && this.camera) {
      this.renderer.render(this.scene, this.camera)
      if (this.cssRenderer) {
        this.cssRenderer.render(this.cssScene, this.camera)
      }
    }
  },
  panCamera (e) {
    if (this.cameraAnimation.position) {
      this.cameraAnimation.position.pause()
    }
    if (this.cameraAnimation.rotation) {
      this.cameraAnimation.rotation.pause()
    }
    let mouseX = (e.clientX / window.innerWidth * 2 - 1)
    let mouseY = (e.clientY / window.innerHeight * 2 - 1)

    let positionFactor = this.positionFactor
    if (!this.camera.originalPosition) {
      this.camera.originalPosition = {
        x: this.camera.position.x,
        y: this.camera.position.y,
        z: this.camera.position.z
      }
    }
    let positionX = mouseX * positionFactor
    let positionY = mouseY * positionFactor
    this.cameraOffsets.position.x = positionX
    this.cameraOffsets.position.y = positionY

    this.cameraAnimation.position = TweenLite.to(this.camera.position, 1, {
      x: this.camera.originalPosition.x + this.cameraOffsets.position.x,
      y: this.camera.originalPosition.y + this.cameraOffsets.position.y,
      onUpdate () {
        this.emitMouseMove()
      },
      onUpdateScope: this
    }, 1)

    let rotationFactor = -0.075
    if (this.currentPositionIndex === 'where') {
      rotationFactor = -0.05
    }
    if (!this.camera.originalRotation) {
      this.camera.originalRotation = {
        x: this.camera.rotation.x,
        y: this.camera.rotation.y,
        z: this.camera.rotation.z
      }
    }
    let rotationX = mouseY * rotationFactor
    let rotationY = mouseX * rotationFactor
    if (this.currentPositionIndex === 'where') {
      rotationY -= 0.125
    }
    this.cameraOffsets.rotation.x = rotationX
    this.cameraOffsets.rotation.y = rotationY
    this.cameraAnimation.rotation = TweenLite.to(this.camera.rotation, 1, {
      x: this.camera.originalRotation.x + this.cameraOffsets.rotation.x,
      y: this.camera.originalRotation.y + this.cameraOffsets.rotation.y
    }, 1)
  },
  setSceneBackgroundByZoneIndex (index) {
    switch (utils.cleanChapterIndex(index)) {
      case 0:
      case 1:
      case 'where':
      case 'double-dutch':
      case 'who':
      case 'what':
      case 'why':
      case 'when':
      case 'extremes':
      case 'the-end':
      case 'not implemented':
        // this.scene.background = new THREE.Color(0x0071ff)
        break
      default:
        // this.scene.background = new THREE.Color(0xffffff)
    }
  },
  createRaycasterAndMouse (e) {
    let raycaster
    let mouse
    if (e) {
      raycaster = new THREE.Raycaster()
      mouse = new THREE.Vector2()
      mouse.x = (e.clientX / window.innerWidth) * 2 - 1
      mouse.y = -(e.clientY / window.innerHeight) * 2 + 1
      raycaster.setFromCamera(mouse, this.camera)
      this.previousRaycaster = raycaster
      this.previousMouse = mouse
    } else {
      raycaster = this.previousRaycaster
      mouse = this.previousMouse
    }
    return {raycaster, mouse}
  },
  onMouseMove (e) {
    if (!this.cameraLocked) {
      this.panCamera(e)
      this.emitMouseMove(e)
    }
  },
  emitMouseMove (e) {
    const {raycaster, mouse} = this.createRaycasterAndMouse(e)
    if (!e) {
      e = this.previousMouseMoveEvent
    }
    this.$bus.$emit('mouse-move', {mouseEvent: e, raycaster, mouse})
    this.previousMouseMoveEvent = e
  },
  onClick (e, moved = false) {
    if (!this.cameraLocked) {
      if (e.preventDefault) {
        e.preventDefault()
      }
      const {raycaster, mouse} = this.createRaycasterAndMouse(e)
      this.$bus.$emit('click', {mouseEvent: e, raycaster, mouse, moved})
    }
  },
  gotoObject (object, helicopter = false) {
    let toPositionMesh = object.toPosition
    this.scene.updateMatrixWorld()
    let toPosition = utils.getCenterPoint(toPositionMesh, THREE)
    this.gotoPosition(toPosition, helicopter)
  },
  gotoPosition (toPosition, helicopter = false, currentPositionIndex) {
    this.currentPositionIndex = currentPositionIndex
    this.scene.updateMatrixWorld()
    let point = utils.getCenterPoint(toPosition, THREE)
    return this.tweenCameraTo({
      x: point.x,
      y: point.y,
      z: point.z
    }, helicopter)
  },
  tweenCameraTo (to, helicopter) {
    return new Promise((resolve, reject) => {
      let duration = helicopter ? 2 : 0.8
      let tweenObject = {
        x: this.camera.position.x,
        y: this.camera.position.y,
        z: this.camera.position.z,
        val: 0
      }
      let vars = {
        x: to.x,
        y: to.y,
        z: to.z,
        val: 1,
        onUpdate: (o) => {
          let y = o.y + this.cameraOffsets.position.y
          this.camera.position.set(
            o.x + this.cameraOffsets.position.x,
            y,
            o.z + this.cameraOffsets.position.z)
          this.camera.originalPosition = {x: o.x, y: o.y, z: o.z}
        },
        onUpdateParams: [tweenObject],
        onComplete: () => {
          this.cameraLocked = false
          resolve()
        }
      }
      if (helicopter) {
        vars.easing = Power4.easeIn
      }
      if (this.cameraAnimation.position) {
        this.cameraAnimation.position.pause()
      }
      this.cameraLocked = true
      TweenLite.to(tweenObject, duration, vars)
    })
  }
}

export default THREEWorld



// WEBPACK FOOTER //
// ./src/world/THREEWorld.js